import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PartsPanel from '../../../../../../components/Parts/PartsPanel';
import NoteWithStamp from '../../../../../../components/Parts/NoteWithStamp';
import {
  partsForMpiWorkItem, approvedPartsTotalForMpiWorkItem, tabWorkItemPartsEnabled, tabPartFilesEnabled,
} from '../../../../../../components/Parts/partsUtils';
import { updateMpiWorkItem } from '../../../../../../actions/apiMpiWorkItems';

const PartsSection = ({ mpiWorkItem, vehicleId, tab }) => {
  const dispatch = useDispatch();
  const active_vehicle = useSelector(state => state.settings_refresh?.active_vehicle || {});
  const all_tabs = useSelector(state => state.settings_site?.all_tabs || []);
  const currentUser = useSelector(state => state.current_user || {});
  const currentUserProfile = useSelector(state => state.settings_users?.current_user_profile || {});
  const uid = parseInt(currentUser.user, 10) || currentUserProfile?.id || null;

  const enabled = useMemo(() => tabWorkItemPartsEnabled(all_tabs, tab), [all_tabs, tab]);
  const showFiles = useMemo(() => tabPartFilesEnabled(all_tabs, tab), [all_tabs, tab]);

  const parts = useMemo(
    () => partsForMpiWorkItem(active_vehicle, mpiWorkItem.id),
    [active_vehicle, mpiWorkItem.id],
  );

  const approvedTotal = useMemo(
    () => approvedPartsTotalForMpiWorkItem(active_vehicle, mpiWorkItem.id),
    [active_vehicle, mpiWorkItem.id],
  );

  const locked = ['approved', 'completed'].includes(mpiWorkItem.ro_status);

  const [note, setNote] = useState(mpiWorkItem.parts_note || '');

  useEffect(() => {
    if (!enabled || parts.length === 0) return;
    if (Math.abs(Number(mpiWorkItem.parts_total || 0) - approvedTotal) < 0.005) return;
    const laborTotal = Number(mpiWorkItem.labor_total || 0);
    dispatch(updateMpiWorkItem(mpiWorkItem.id, {
      vehicle_id: vehicleId,
      parts_total: Number(approvedTotal.toFixed(2)),
      estimate_total: Number((approvedTotal + laborTotal).toFixed(2)),
    }));
  }, [enabled, approvedTotal, parts.length, mpiWorkItem.parts_total, mpiWorkItem.labor_total]);

  const saveNote = () => {
    if ((note || '') === (mpiWorkItem.parts_note || '')) return;
    dispatch(updateMpiWorkItem(mpiWorkItem.id, {
      vehicle_id: vehicleId,
      parts_note: note,
      parts_note_by_uid: uid,
      parts_note_by_date: new Date().toISOString(),
    }));
  };

  if (!enabled) return null;

  return (
    <PartsPanel
      vehicleId={vehicleId}
      parts={parts}
      scope="new_work_items"
      mpiWorkItemId={mpiWorkItem.id}
      title="Parts"
      showFiles={showFiles}
      locked={locked}
    >
      <NoteWithStamp
        value={note}
        onChange={e => setNote(e.target.value)}
        onBlur={saveNote}
        byUid={mpiWorkItem.parts_note_by_uid}
        byDate={mpiWorkItem.parts_note_by_date}
      />
    </PartsPanel>
  );
};

export default PartsSection;
